import { jsx as i, jsxs as N } from "../../_virtual/jsx-runtime.mjs";
import { useMemo as n, useCallback as y } from "react";
import I from "../ReoIcon/ReoIcon.mjs";
import { reoLinkIcon as z, disabledColor as a, defaultColor as P, defaultHoverColor as R, reoLink as U, reoLinkAnimate as w, sizeMap as x, reoLinkContent as T, reoLinkIconWrap as j, reoLinkIconGroup as A, reoLinkIconAnimate as D } from "./css/ReoLink.mjs";
import { omitPropsKeys as K, defaultReoLinkProps as o } from "./const.mjs";
import f from "../../depend/classnames/index.mjs";
import { getValByDef as l } from "../../utils/getValByDef.mjs";
import { useOmitProps as M } from "../../hook/useOmitProps.mjs";
import "../ReoForm/context/FormItemInputContext.mjs";
import "../ReoForm/context/ReoFormCompContext.mjs";
import { useTheme as g } from "../../hook/useTheme.mjs";
import { EThemeTemplate as B } from "../../common/type.mjs";
const E = (e) => {
  const b = M(e, K), t = n(() => l(e.size, o.size), [e.size]), k = y((h) => {
    var u;
    if (e.disabled) {
      h.preventDefault();
      return;
    }
    (u = e.onClick) == null || u.call(e, h);
  }, [e]), d = g({ theme: e.theme, template: B.LINK }), v = n(() => /* @__PURE__ */ i(
    I,
    {
      className: z,
      color: "var(--color)",
      width: "var(--icon-width)",
      name: l(e.icon, o.icon)
    }
  ), [e.icon]), r = n(
    () => e.disabled ? a : l(e.color, P),
    [e.color, e.disabled]
  ), c = n(
    () => e.disabled ? a : l(e.color, R),
    [e.color, e.disabled]
  ), m = n(
    () => e.disabled ? a : l(e.hoverColor, c),
    [c, e.disabled, e.hoverColor]
  ), C = n(
    () => ({
      "--color": r,
      "--hover-color": m,
      cursor: e.disabled ? "not-allowed" : "pointer",
      ...e.style
    }),
    [r, m, e.disabled, e.style]
  ), s = n(() => l(e.underline, o.underline) ? "underline" : l(e.hoverUnderline, o.hoverUnderline) ? "hoverUnderline" : "none", [e.hoverUnderline, e.underline]), L = n(() => f(
    U,
    e.disabled ? null : w[s],
    x[t],
    e.className,
    d
  ), [e.className, e.disabled, t, s, d]);
  return /* @__PURE__ */ N(
    "a",
    {
      "aria-disabled": e.disabled,
      className: L,
      style: C,
      href: e.disabled ? "" : e.href,
      onClick: k,
      ...b,
      children: [
        /* @__PURE__ */ i("span", { className: T, children: e.children }),
        /* @__PURE__ */ i("span", { className: j, children: /* @__PURE__ */ i("span", { className: f(A, e.disabled ? null : D), children: v }) })
      ]
    }
  );
};
E.displayName = "ReoLink";
export {
  E as default
};
//# sourceMappingURL=ReoLink.mjs.map
